module.exports = __webpack_public_path__ + "img/arrowLeft-grey.35647b70.svg";